import * as React from 'react'
import styled from 'styled-components'
import { colors } from '@components/shared/colors'
import { config } from 'react-awesome-styled-grid'

type PropsType = {
  title: string
}

export function PageTitle (props: PropsType): React.ReactNode {
  return (
    <TitleText>{props.title}</TitleText>
  )
}

const TitleText = styled.h1<any>`
  font-family: "Queens Condensed Light";
  font-size: 36px;
  font-style: normal;
  font-weight: 500;
  line-height: 100%;
  color: ${colors.white};
  margin: 0;
  margin-top: 20px;
  margin-bottom: 16px;
  ${(props: any): any => config(props).media.md`
    font-size: 48px;
  `}
  ${(props: any): any => config(props).media.lg`
    font-size: 60px;
  `}
`
